/*
 * O mesmo build atende quatro enderecos. A primeira parte do nome do servidor
 * diz qual area abrir:
 *
 *   credenciamento.festivaldorio.com.br  formularios de credenciamento
 *   filmes.festivaldorio.com.br          pagina de fotos/materiais do filme
 *   premierebrasil.festivaldorio.com.br  inscricao da Premiere Brasil
 *   qualquer outro (sistema...)          a area logada
 *
 * O prefixo "dev-" (dev-credenciamento...) e o dominio .test local valem do
 * mesmo jeito. Acessado por IP ou localhost, abre sempre o sistema.
 */
export const PUBLIC_AREAS = ['credenciamento', 'filmes', 'premierebrasil'];

// O catalogo e impresso: o link de fotos sai sempre com o endereco de producao.
export const FILMES_PRODUCTION_URL = 'https://filmes.festivaldorio.com.br';

const hostParts = () => {
  const { hostname } = window.location;
  const isIp = /^[\d.]+$/.test(hostname) || hostname.includes(':');

  return isIp ? [hostname] : hostname.split('.');
};

export const getArea = () => {
  const name = hostParts()[0].replace(/^dev-/, '');

  return PUBLIC_AREAS.includes(name) ? name : 'sistema';
};

/*
 * Endereco completo de uma area, montado a partir do endereco atual:
 * sistema.festivaldorio.com.br -> credenciamento.festivaldorio.com.br,
 * dev-sistema... -> dev-credenciamento..., sistema.festivaldorio.test ->
 * credenciamento.festivaldorio.test. Sem subdominio (IP, localhost), devolve
 * o caminho no proprio endereco.
 */
export const getAreaUrl = (area, path = '') => {
  const [first, ...rest] = hostParts();

  if (rest.length === 0) {
    return `${window.location.origin}${path}`;
  }

  const prefix = first.startsWith('dev-') ? 'dev-' : '';
  const port = window.location.port ? `:${window.location.port}` : '';

  return `${window.location.protocol}//${prefix}${area}.${rest.join(
    '.',
  )}${port}${path}`;
};
